import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./core/home-redirect.component').then(m => m.HomeRedirectComponent),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard],
  },
  {
    path: 'vehicles',
    loadComponent: () => import('./features/vehicles/vehicles.component').then(m => m.VehiclesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'vehicles/:vehicleId/events',
    loadComponent: () => import('./features/events/events.component').then(m => m.EventsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'stations',
    loadComponent: () => import('./features/stations/stations.component').then(m => m.StationsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'service-points',
    loadComponent: () => import('./features/service-points/service-points.component').then(m => m.ServicePointsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'service-types',
    loadComponent: () => import('./features/service-types/service-types.component').then(m => m.ServiceTypesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'expense-types',
    loadComponent: () => import('./features/expense-types/expense-types.component').then(m => m.ExpenseTypesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'subscription',
    loadComponent: () => import('./features/subscription/subscription.component').then(m => m.SubscriptionComponent),
    canActivate: [authGuard],
  },
  {
    path: 'household',
    loadComponent: () => import('./features/household/household.component').then(m => m.HouseholdComponent),
    canActivate: [authGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./features/reports/reports.component').then(m => m.ReportsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'reports/compare',
    loadComponent: () => import('./features/reports/vehicle-comparison.component').then(m => m.VehicleComparisonComponent),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'notifications',
    loadComponent: () => import('./features/notifications/notifications.component').then(m => m.NotificationsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'feedback',
    loadComponent: () => import('./features/feedback/feedback.component').then(m => m.FeedbackComponent),
    canActivate: [authGuard],
  },
  {
    path: 'feedback/:id',
    loadComponent: () => import('./features/feedback/feedback-detail.component').then(m => m.FeedbackDetailComponent),
    canActivate: [authGuard],
  },
  {
    path: 'changelog',
    loadComponent: () => import('./features/changelog/changelog.component').then(m => m.ChangelogComponent),
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin-shell.component').then(m => m.AdminShellComponent),
    canActivate: [adminGuard],
    children: [
      { path: '', redirectTo: 'kpi', pathMatch: 'full' },
      {
        path: 'kpi',
        loadComponent: () => import('./features/admin/admin-kpi.component').then(m => m.AdminKpiComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./features/admin/admin-users.component').then(m => m.AdminUsersComponent),
      },
      {
        path: 'users/:id',
        loadComponent: () => import('./features/admin/admin-user-detail.component').then(m => m.AdminUserDetailComponent),
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./features/admin/admin-subscriptions.component').then(m => m.AdminSubscriptionsComponent),
      },
      {
        path: 'master-data',
        loadComponent: () => import('./features/admin/admin-master-data.component').then(m => m.AdminMasterDataComponent),
      },
      {
        path: 'parameters',
        loadComponent: () => import('./features/admin/admin-parameters.component').then(m => m.AdminParametersComponent),
      },
      {
        path: 'audit-logs',
        loadComponent: () => import('./features/audit-log/audit-log.component').then(m => m.AuditLogComponent),
      },
      {
        path: 'monitoring',
        loadComponent: () => import('./features/admin/admin-monitoring.component').then(m => m.AdminMonitoringComponent),
      },
      {
        path: 'changelog',
        loadComponent: () => import('./features/admin/admin-changelog.component').then(m => m.AdminChangelogComponent),
      },
      {
        path: 'docs',
        loadComponent: () => import('./features/admin/admin-docs.component').then(m => m.AdminDocsComponent),
      },
      {
        path: 'emails',
        loadComponent: () => import('./features/admin/admin-emails.component').then(m => m.AdminEmailsComponent),
      },
      {
        path: 'feedback',
        loadComponent: () => import('./features/admin/admin-feedback.component').then(m => m.AdminFeedbackComponent),
      },
      {
        path: 'feedback/:id',
        loadComponent: () => import('./features/admin/admin-feedback-detail.component').then(m => m.AdminFeedbackDetailComponent),
      },
    ],
  },
  ...(!environment.useKeycloak ? [{
    path: 'login',
    loadComponent: () => import('./features/auth/mock-login.component').then(m => m.MockLoginComponent),
  }] : []),
  { path: '**', redirectTo: 'dashboard' },
];
